export default class HekateOptionListElement {
    constructor({ value, displayName }) {
        this.value = value;
        this.displayName = displayName;
    }
    static fromBlob(blob) {
        const displayName = typeof blob.displayName !== 'undefined' ? blob.displayName : '';
        const value = typeof blob.value !== 'undefined' ? blob.value : '';
        return new HekateOptionListElement({
            displayName,
            value,
        });
    }
    /** Logically compare (suitable for serialization check) */
    compareTo(rhs) {
        return this.displayName === rhs.displayName && this.value === rhs.value;
    }
}
